import blog_bg from "../assets/images/bg_img.svg";
import bulb_img from "../assets/images/about_first.svg";
import students_img from "../assets/images/about_second.svg";
import india_img from "../assets/images/india.svg";
import usa_img from "../assets/images/usa.svg";


const ABOUT_DATA={
    about_heading:"Your Trusted Partner in Smarter Money Transfers",
    hero_data:"At MoneyRateFinder, our mission is to make international money transfers easier, faster, and more cost-effective for everyone. We provide a comprehensive platform that lets you compare hundreds of remittance providers based on exchange rates, transfer fees, delivery times, and payment options. Whether you’re sending money to loved ones, managing international business payments, or exploring affordable transfer options, MoneyRateFinder has you covered.",
    hero_para1:"Transparency is at the heart of everything we do. We provide clear and detailed breakdowns of transfer fees, delivery times, and payout methods, so you know exactly what to expect before initiating a transfer. This empowers you to send money with confidence, knowing there are no hidden surprises along the way",
    hero_para2:"Choose MoneyRateFinder and experience the smarter way to send money globally. Empower your transfers with confidence, clarity, and convenience.",
    bg_heading:"Find the cheapest rate to transfer your hard earned money",
    bg_img:blog_bg,
    top_companies_heading:"Top Companies",
    top_companies:{
        data:[
            "Wise",
            "Atlantic Money",
            "XE Money Transfer",
            "Instarem",
            "Transfer Go",
            "OFX",
            "Zing"
        ]
    },
    send_money_heading:"Send Money Abroad",
    send_money:{
        data:[
            "Send Money to the UK",
            "Send Money to Indian",
            "Send Money to Mexico",
            "Send Money to Canada",
            "Send Money to Australia",           
        ]
    },
    helpful_guides_heading:"Helpful Guides",
    helpful_guides:{
           data:[
            "The Fastest Way To Send Money Abroad",
            "The Cheapest Way To Send Money Abroad",
            "The Top Money Transfer Companies",
            "How To Send Money Via Credit Card",
            "How To Make A Wire Transfer",           
            "How To Send Money Via Email",           
            "How To Send Money Using An IBAN",           
            "Best Money Transfer Apps",           
            "Can I Use PayPal to Transfer Money Internationally?",           
            "Send Money With a Debit Card",           
        ]
    },
    transfer_routes_heading:"Popular Transfer Routes",
    transfer_routes:{
        data:[
            "From United States to India",
            "From Saudi Arabia to Mexico",
            "From UAE to China",
            "From Germany to Philippines",
            "From UK to Egypt",           
            "From Kuwait to Pakistan",           
        ]
    },

    first_div:{
        first:"At MoneyRateFinder, our mission is to make international money transfers easier, faster, and more cost-effective for everyone. We provide a comprehensive platform that lets you compare hundreds of remittance providers based on exchange rates, transfer fees, delivery times, and payment options. Whether you’re sending money to loved ones, managing international business payments, or exploring affordable transfer options, MoneyRateFinder has you covered.",
        second:"Transparency is at the heart of everything we do. We provide clear and detailed breakdowns of transfer fees, delivery times, and payout methods, so you know exactly what to expect before initiating a transfer. This empowers you to send money with confidence, knowing there are no hidden surprises along the way",
        third:"Choose MoneyRateFinder and experience the smarter way to send money globally. Empower your transfers with confidence, clarity, and convenience.",
        // fourth:"Here are some additional key points about RemitFinder.",
        // fifth:[
        //     "We are a global platform, supporting more than 35,000 country and currency combinations.",
        //     "We have more than 100 banks, money transfer operators and remittance companies.",
        //     "We have active users in more than 150 countries.",
        //     "We have numerous exclusive partnerships with the best in class money transfer companies and operators, this allows us to get our users the best rates as well as attractive deals and promotions.",
        //     "Our services are multi-channel and can be accessed via web as well as mobile (Android and iOS mobile apps).",
        //     "Our services are completely free for our customers, and we do not charge them for anything including email and mobile notifications for rate alerts.",
        //     "Our rates are near real time, and we provide rate trend information on our site as well as mobile apps.",
        // ]

    },

    our_story:{
        heading:"Our Story",
        first_para:<>
        At Money Rate Finder, we are a group of problem solvers, innovators, and finance enthusiasts with a passion for building smart financial tools. Our journey began with a simple yet crucial question: Why is sending money across borders still so complicated and costly?
        </>,
        second_para:<>
        We saw countless individuals struggling to find the best exchange rates and lowest transfer fees when sending money internationally. Hidden charges, confusing processes, and lack of transparency made global remittances a challenge. We knew there had to be a better way.
        </>,
        third_para:<>
        With our background in developing finance-related apps, we set out to create a solution that empowers users with real-time rate comparisons from top remittance providers. Our platform simplifies the process, helping customers save both time and money by making informed decisions.
        </>,
    },
    our_mission:{
        heading:"Our Mission: Transparency, Convenience, and Savings",
        first_para:<>
        Money Rate Finder was built with a clear mission: to bring transparency to the remittance industry and provide users with a hassle-free way to compare rates. We believe that everyone deserves access to fair and competitive exchange rates, whether they are supporting family overseas, paying for services, or handling international business transactions.
        </>,
        second_para:<>
       We don’t just build financial apps; we craft solutions that make a real difference in people’s lives. Our team continuously works to enhance our platform, integrating user feedback and leveraging cutting-edge technology to ensure a seamless experience.
        </>,

    },
    looking_ahead:{
        heading:"Looking Ahead",
        first_para:<>
        As we grow, we remain committed to innovation. Our vision is to expand our suite of financial tools, offering more solutions that simplify personal finance, cross-border payments, and money management.
        </>,
        second_para:<>
       At Money Rate Finder, we are more than just a remittance comparison site—we are your trusted partner in making smarter financial decisions
        </>,

    },

    bulb_img:bulb_img,
    students_img:students_img,

    best_transfer_rates:{
        heading:"Find the economical rate to transfer your hard earned money",
        data:[{
            title:"Transfer money from",
            img:india_img,
            country:"India"
        },
        {
            title:"Transfer money to",
            img:usa_img,
            country:"USA"
        },]
    }



}

export default ABOUT_DATA;